import {
  CAMPOS_DATOS_GENERALES as DG_INI_TO,
  CAMPOS_ANTECEDENTES,
  CAMPOS_AVD,
  CAMPOS_AVD_INSTRUMENTALES,
  CAMPOS_JUEGO,
  CAMPOS_DESEMPENO_ESCOLAR,
  CAMPOS_OCIO_TIEMPO_LIBRE,
  CAMPOS_COMUNICACION_SOCIAL,
  CAMPOS_PROCESAMIENTO_SENSORIAL,
  CAMPOS_MOTRICIDAD_FINA,
  CAMPOS_MOTRICIDAD_GRUESA,
  CAMPOS_CIERRE as CIERRE_INI_TO,
} from './camposEvalInicial';
import {
  CAMPOS_MOTIVO,
  CAMPOS_TEXTO_LARGO,
  CAMPOS_ABVD,
  CAMPOS_AIVD_BASE,
  CAMPOS_AIVD_ESCOLAR,
  CAMPOS_MOTOR,
  CAMPOS_COGNITIVO,
  CAMPOS_FIRMAS,
  filtrarCamposGenerales,
} from './camposEvalPlan';
import {
  CAMPOS_DATOS_GENERALES as DG_AV_TO,
  CAMPOS_CONTEXTO,
  CAMPOS_EVOLUCION,
  CAMPOS_CIERRE as CIERRE_AV_TO,
} from './camposEvalAvance';
import {
  CAMPOS_DATOS_GENERALES as DG_INI_SENS,
  CAMPOS_ANTECEDENTES as ANT_SENS,
  CAMPOS_AVD as AVD_SENS,
  CAMPOS_AVD_INSTRUMENTALES as AVD_INST_SENS,
  CAMPOS_CONDUCTA,
  CAMPOS_COGNICION_BASE,
  CAMPOS_SENSORIAL_SISTEMAS,
  CAMPOS_MOTRICIDAD_FINA as MF_SENS,
  CAMPOS_MOTRICIDAD_GRUESA as MG_SENS,
  CAMPOS_CIERRE as CIERRE_INI_SENS,
  CAMPOS_SOCIAL,
  CAMPOS_OBSERVACIONES,
} from './camposEvalInicialSensorial';
import {
  CAMPOS_DATOS_GENERALES as DG_PLAN_SENS,
  CAMPOS_SECCIONES as SEC_PLAN_SENS,
} from './camposEvalPlanSensorial';
import {
  CAMPOS_DATOS_GENERALES as DG_AV_SENS,
  CAMPOS_SECCIONES as SEC_AV_SENS,
  CAMPOS_CIERRE as CIERRE_AV_SENS,
} from './camposEvalAvanceSensorial';

export const RAMA_OCUPACIONAL = 'OCUPACIONAL';
export const RAMA_SENSORIAL = 'SENSORIAL';
export const RAMAS_CON_PLANTILLA = [RAMA_OCUPACIONAL, RAMA_SENSORIAL];

const emptyGrupo = (keys) =>
  keys.reduce((acc, key) => {
    acc[key] = '';
    return acc;
  }, {});

export const ramaDesdeEspecialidad = (codigo, etiqueta) => {
  const texto = String(`${codigo || ''} ${etiqueta || ''}`).toUpperCase();
  if (texto.indexOf('SENSORIAL') >= 0) {
    return RAMA_SENSORIAL;
  }
  if (texto.indexOf('OCUPACIONAL') >= 0 || texto.indexOf('OCUPAC') >= 0) {
    return RAMA_OCUPACIONAL;
  }
  if (texto.indexOf('PSICOLOG') >= 0) {
    return 'PSICOLOGIA';
  }
  if (texto.indexOf('FONOAUDIO') >= 0) {
    return 'FONOAUDIOLOGIA';
  }
  return 'OTRA';
};

export const tienePlantillaInforme = (rama) => RAMAS_CON_PLANTILLA.indexOf(rama) >= 0;

export const etiquetaRama = (rama) => {
  if (rama === RAMA_SENSORIAL) return 'Integración Sensorial';
  if (rama === RAMA_OCUPACIONAL) return 'Terapia Ocupacional';
  if (rama === 'PSICOLOGIA') return 'Psicología';
  if (rama === 'FONOAUDIOLOGIA') return 'Fonoaudiología';
  return rama || 'Otra';
};

export const tituloPlantilla = (tipo, rama, numeroAvance = 0) => {
  if (tipo === 'evaluacion_inicial') {
    return rama === RAMA_SENSORIAL
      ? 'Evaluación Inicial — Integración Sensorial'
      : 'Evaluación Inicial de Terapia Ocupacional';
  }
  if (tipo === 'evaluacion_plan') {
    return rama === RAMA_SENSORIAL
      ? 'Informe de Evaluación y Plan — Integración Sensorial'
      : 'Informe de Evaluación y Plan de Terapia Ocupacional';
  }
  if (tipo === 'avance') {
    const n = numeroAvance ? ` ${numeroAvance}` : '';
    return rama === RAMA_SENSORIAL
      ? `Informe de avance${n} — Integración Sensorial`
      : `Informe de avance${n} de Terapia Ocupacional`;
  }
  return 'Informe';
};

export const emptyDatosEvalInicial = (base = {}) => ({
  datosGenerales: {
    nombreApellido: '',
    cedula: '',
    sexo: '',
    fnacimiento: '',
    edad: '',
    edadTexto: '',
    diagnostico: '',
    nombreMadre: '',
    ocupacionMadre: '',
    nombrePadre: '',
    ocupacionPadre: '',
    hermanos: '',
    colegio: '',
    gradoEscolar: '',
    referencia: '',
    condicionSalud: '',
    alergias: '',
    medicamentos: '',
    fechaInforme: '',
    fechaInicioTerapia: '',
    ...base,
  },
  antecedentes: emptyGrupo(['preNatal', 'natal', 'postNatal']),
  avd: emptyGrupo([
    'vestido',
    'higiene',
    'alimentacion',
    'controlEsfinteres',
    'higieneSueno',
    'movilidad',
  ]),
  avdInstrumentales: emptyGrupo(['tareasHogar', 'manejoDinero']),
  juego: emptyGrupo(['tipoJuego']),
  desempenoEscolar: emptyGrupo(['participacion']),
  ocioTiempoLibre: emptyGrupo(['participacion']),
  comunicacionSocial: emptyGrupo(['conducta', 'interaccionSocial', 'lenguaje']),
  procesamientoSensorial: emptyGrupo([
    'visual',
    'tactil',
    'auditivo',
    'gustativo',
    'olfativo',
    'propioceptivo',
    'interoceptivo',
    'vestibular',
  ]),
  motricidadFina: emptyGrupo([
    'dominancia',
    'coordinacionBimanual',
    'ojoMano',
    'ensartar',
    'encajar',
    'enhebrar',
    'bolitas',
    'amasaMasilla',
    'aplastaMasilla',
    'cortaMasillaUtensilios',
    'rasgarPapel',
    'coloreoLimites',
    'coloreoDireccion',
    'coloreoFuerza',
    'trazosRectasHV',
    'trazosZigzag',
    'trazosCurvas',
    'numeros',
    'letras',
    'dibujos',
    'tijerasRecta',
    'tijerasCurvas',
    'tijerasZigzag',
    'agarreLapiz',
    'fuerzaLapiz',
    'observaciones',
  ]),
  motricidadGruesa: emptyGrupo([
    'coordinacionBilateral',
    'oculomotor',
    'lateralidad',
    'equilibrioEstatica',
    'equilibrioMovimiento',
    'equilibrioUnPie',
    'caminarLineaRecta',
    'saltar',
    'saltarUnPie',
    'saltarAmbosPies',
    'caminarPuntillas',
    'camina',
    'corre',
    'trepa',
    'subeEscalerasAlterna',
    'subeEscalerasVerticales',
    'pateaEstatica',
    'pateaMovimiento',
    'lanzaAmbasManos',
    'atrapaAmbasManos',
    'lanzaUnaMano',
    'atrapaUnaMano',
    'encestaFijo',
    'encestaMovimiento',
    'halar',
    'empujar',
    'fuerza',
    'observaciones',
  ]),
  objetivos: '',
  recomendaciones: '',
  recibido: '',
});

export const emptyDatosEvalPlan = (base = {}) => ({
  datosGenerales: {
    nombreApellido: '',
    cedula: '',
    fnacimiento: '',
    edad: '',
    domicilio: '',
    sexo: '',
    diagnostico: '',
    referidoPor: '',
    colegio: '',
    escuela: '',
    gradoEscolar: '',
    medicamentos: '',
    alergias: '',
    nombreMadre: '',
    telefonoMadre: '',
    nombrePadre: '',
    fechaInforme: '',
    fechaInicioTerapia: '',
    ...base,
  },
  motivoMenor: '',
  motivoAcompanante: '',
  motivoReferido: '',
  perfilOcupacional: '',
  objetivo: '',
  organizacionComportamiento: '',
  abvd: emptyGrupo(['alimentacion', 'vestido', 'controlEsfinter', 'higiene', 'descansoSueno']),
  aivd: emptyGrupo([
    'tareasCasa',
    'pantallas',
    'dinero',
    'cuidadoOtros',
    'tiempoPlanificacion',
    'transporte',
  ]),
  motor: emptyGrupo(['gruesas', 'finas', 'observacionesPosturales', 'lateralidad']),
  cognitivo: emptyGrupo([
    'percepcionVisual',
    'funcionesEjecutivas',
    'atencion',
    'memoria',
    'procesamientoEspacial',
  ]),
  sensorial: '',
  comunicacion: '',
  evaluaciones: '',
  impresionOcupacional: '',
  objetivosTrimestre: '',
  recomendaciones: '',
  firmaTerapeuta: '',
  firmaPadre: '',
});

export const emptyDatosEvalAvance = (base = {}) => ({
  datosGenerales: {
    nombreApellido: '',
    fnacimiento: '',
    edad: '',
    edadTexto: '',
    diagnostico: '',
    nombreTerapeuta: '',
    fechaInforme: '',
    fechaInicioTerapia: '',
    ...base,
  },
  areasFinalidad: '',
  vecesPorSemana: '',
  diasTerapiaTexto: '',
  horarioDesde: '',
  horarioHasta: '',
  asistencia: '',
  evolucionIntro: '',
  regulacion: '',
  atencion: '',
  motor: '',
  procesamientoSensorial: '',
  conductual: '',
  conclusion: '',
  objetivosTerapeuticos: '',
  recomendaciones: '',
});

export const emptyDatosEvalInicialSensorial = (base = {}) => ({
  ...emptyDatosEvalInicial(base),
  avd: emptyGrupo(['vestido', 'higiene', 'alimentacion']),
  avdInstrumentales: { instrumentales: '' },
  conducta: { conducta: '' },
  cognicion: emptyGrupo([
    'comunicacion',
    'percepcion',
    'atencion',
    'concentracion',
    'seguimientoIndicaciones',
    'memoria',
    'esquemaCorporal',
    'relacionesEspaciales',
    'colores',
    'figurasGeometricas',
    'numeros',
    'seguimientoPatrones',
    'copia',
    'cierreVisual',
    'figuraFondo',
    'lectura',
    'escritura',
    'procedimientosMatematicos',
    'desempenoEscolar',
    'social',
  ]),
  sistemasSensoriales: emptyGrupo([
    'propioceptivo',
    'vestibular',
    'tactil',
    'auditivo',
    'visual',
    'olfato',
    'gusto',
    'interoceptivo',
  ]),
  observacionesGenerales: '',
});

export const emptyDatosEvalPlanSensorial = (base = {}) => ({
  datosGenerales: {
    nombreApellido: '',
    fnacimiento: '',
    edad: '',
    edadTexto: '',
    centroEducativo: '',
    diagnostico: '',
    nombreTerapeuta: '',
    fechaEvaluacion: '',
    fechaInforme: '',
    ...base,
  },
  motivoReferencia: '',
  antecedentesRelevantes: '',
  instrumentosUtilizados: '',
  metodosEvaluacion: '',
  observacionClinica: '',
  resultadosPerfilSensorial: '',
  conclusion: '',
  planIntervencion: '',
  objetivosIntervencion: '',
  recomendaciones: '',
  sugerencias: '',
  dietaSensorial: '',
});

export const emptyDatosEvalAvanceSensorial = (base = {}) => ({
  datosGenerales: {
    nombreApellido: '',
    fnacimiento: '',
    edad: '',
    edadTexto: '',
    escuela: '',
    tutorLegal: '',
    domicilio: '',
    fechaEvaluacion: '',
    fechaInforme: '',
    diagnostico: '',
    elaboradoPor: '',
    cantidadSesionesRecibidas: '',
    ...base,
  },
  motivoConsulta: '',
  conductaObservada: '',
  tecnicasUtilizadas: '',
  aspectosFortalecer: '',
  recomendaciones: '',
  recomendacionesCentroEducativo: '',
  cantidadSesiones: '',
  recibidoPadre: '',
});

const vacioPorTipo = (tipo, rama) => {
  if (rama === RAMA_SENSORIAL) {
    if (tipo === 'evaluacion_inicial') return emptyDatosEvalInicialSensorial();
    if (tipo === 'evaluacion_plan') return emptyDatosEvalPlanSensorial();
    return emptyDatosEvalAvanceSensorial();
  }
  if (tipo === 'evaluacion_inicial') return emptyDatosEvalInicial();
  if (tipo === 'evaluacion_plan') return emptyDatosEvalPlan();
  return emptyDatosEvalAvance();
};

const fusionar = (base, extra) => {
  if (!extra || typeof extra !== 'object' || Array.isArray(extra)) {
    return base;
  }
  const out = { ...base };
  Object.keys(extra).forEach((key) => {
    const val = extra[key];
    if (
      val &&
      typeof val === 'object' &&
      !Array.isArray(val) &&
      base[key] &&
      typeof base[key] === 'object' &&
      !Array.isArray(base[key])
    ) {
      out[key] = fusionar(base[key], val);
    } else if (val !== undefined && val !== null) {
      out[key] = val;
    }
  });
  return out;
};

export const parseDatosInforme = (cuerpo, tipo, rama) => {
  const base = vacioPorTipo(tipo, rama);
  if (!cuerpo) {
    return base;
  }
  if (typeof cuerpo === 'object') {
    return fusionar(base, cuerpo);
  }
  const texto = String(cuerpo).trim();
  if (!texto) {
    return base;
  }
  if (texto.charAt(0) !== '{') {
    return base;
  }
  try {
    const parsed = JSON.parse(texto);
    return fusionar(base, parsed);
  } catch (e) {
    return base;
  }
};

export const esCuerpoPlantilla = (cuerpo) => {
  if (!cuerpo) {
    return false;
  }
  if (typeof cuerpo === 'object') {
    return true;
  }
  const texto = String(cuerpo).trim();
  return texto.charAt(0) === '{';
};

const seccion = (titulo, path, campos, grid) => ({
  titulo,
  path,
  campos,
  grid: grid || (path === 'datosGenerales' ? 'datos' : 'campos'),
});

export const seccionesPlantilla = (tipo, rama, datos) => {
  const escolar = Number((datos && datos.datosGenerales && datos.datosGenerales.edad) || 0) > 5;

  if (rama === RAMA_SENSORIAL && tipo === 'evaluacion_inicial') {
    return [
      seccion('Datos generales', 'datosGenerales', DG_INI_SENS),
      seccion('Antecedentes', 'antecedentes', ANT_SENS),
      seccion('Actividades de la vida diaria', 'avd', AVD_SENS),
      seccion('Actividades instrumentales', 'avdInstrumentales', AVD_INST_SENS),
      seccion('Conducta', 'conducta', CAMPOS_CONDUCTA),
      seccion('Cognición', 'cognicion', CAMPOS_COGNICION_BASE.concat(CAMPOS_SOCIAL)),
      seccion('Sistemas sensoriales', 'sistemasSensoriales', CAMPOS_SENSORIAL_SISTEMAS),
      seccion('Motricidad fina', 'motricidadFina', MF_SENS),
      seccion('Motricidad gruesa', 'motricidadGruesa', MG_SENS),
      seccion('Cierre', null, CIERRE_INI_SENS.concat(CAMPOS_OBSERVACIONES)),
    ];
  }

  if (rama === RAMA_SENSORIAL && tipo === 'evaluacion_plan') {
    return [
      seccion('Datos generales', 'datosGenerales', DG_PLAN_SENS),
      ...SEC_PLAN_SENS.map((campo) => seccion(campo.label, null, [campo])),
    ];
  }

  if (rama === RAMA_SENSORIAL && tipo === 'avance') {
    return [
      seccion('Datos generales', 'datosGenerales', DG_AV_SENS),
      ...SEC_AV_SENS.map((campo) => seccion(campo.label, null, [campo])),
      seccion('Cierre', null, CIERRE_AV_SENS),
    ];
  }

  if (tipo === 'evaluacion_inicial') {
    return [
      seccion('Datos generales', 'datosGenerales', DG_INI_TO),
      seccion('Antecedentes', 'antecedentes', CAMPOS_ANTECEDENTES),
      seccion('Actividades básicas de la vida diaria', 'avd', CAMPOS_AVD),
      seccion('Actividades instrumentales de la vida diaria', 'avdInstrumentales', CAMPOS_AVD_INSTRUMENTALES),
      seccion('Juego', 'juego', CAMPOS_JUEGO),
      seccion('Desempeño escolar', 'desempenoEscolar', CAMPOS_DESEMPENO_ESCOLAR),
      seccion('Ocio y tiempo libre', 'ocioTiempoLibre', CAMPOS_OCIO_TIEMPO_LIBRE),
      seccion('Comunicación e interacción social', 'comunicacionSocial', CAMPOS_COMUNICACION_SOCIAL),
      seccion('Procesamiento sensorial', 'procesamientoSensorial', CAMPOS_PROCESAMIENTO_SENSORIAL),
      seccion('Motricidad fina', 'motricidadFina', CAMPOS_MOTRICIDAD_FINA),
      seccion('Motricidad gruesa', 'motricidadGruesa', CAMPOS_MOTRICIDAD_GRUESA),
      seccion('Cierre', null, CIERRE_INI_TO),
    ];
  }

  if (tipo === 'evaluacion_plan') {
    const aivd = escolar ? CAMPOS_AIVD_BASE.concat(CAMPOS_AIVD_ESCOLAR) : CAMPOS_AIVD_BASE;
    return [
      seccion('Datos generales', 'datosGenerales', filtrarCamposGenerales(escolar)),
      seccion('Motivo de consulta', null, CAMPOS_MOTIVO),
      seccion('Actividades básicas de la vida diaria', 'abvd', CAMPOS_ABVD),
      seccion('Actividades instrumentales de la vida diaria', 'aivd', aivd),
      seccion('Área motora', 'motor', CAMPOS_MOTOR),
      seccion('Área cognitiva', 'cognitivo', CAMPOS_COGNITIVO),
      ...CAMPOS_TEXTO_LARGO.map((campo) => seccion(campo.label, null, [campo])),
      seccion('Firmas', null, CAMPOS_FIRMAS),
    ];
  }

  return [
    seccion('Datos generales', 'datosGenerales', DG_AV_TO),
    seccion('Contexto del reporte', null, CAMPOS_CONTEXTO),
    seccion('Evolución terapéutica', null, CAMPOS_EVOLUCION),
    seccion('Conclusión y recomendaciones', null, CIERRE_AV_TO),
  ];
};

export const emptyDatosPlantilla = vacioPorTipo;
